<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <div>
        <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
        {{ $route.name }}
      </div>
      <div>
        <div class="subHeadTitle">
          {{
            getProcedureTypes[$route.params.procedureType]
              ? getProcedureTypes[$route.params.procedureType].name
              : ""
          }}
          /
          {{
            centralization
              ? centralization.identifier + " - " + centralization.name
              : ""
          }}
        </div>
        <div
          class="col2_subHead"
          style="margin-top: 1.2rem; display: flex; justify-content: flex-end"
        >
          <div
            v-if="$route.params.procedureType !== 'achizitie_directa'"
            class="Button1 Btn_center"
            @click="createProcedureDocument"
            style="margin-right: 5px"
          >
            <div class="icon">
              <img
                src="../assets/media/for_table/circle_ADD_new_etap.svg"
                alt=""
              />
            </div>
            <span class="Btn_content">Atribuirea prin procedură </span>
          </div>
          <div class="Button1 Btn_center" @click="openActions">
            <div class="icon">
              <img
                src="../assets/media/for_table/circle_ADD_new_etap.svg"
                alt=""
              />
            </div>
            <span class="Btn_content"> Acțiuni achiziții </span>
          </div>
        </div>
      </div>
    </div>

    <template v-if="PERMISIONS.list">
      <Table
        :key="tableReload"
        :Data="tableData"
        @checkboxManager="checkboxManager"
        @Btn14="viewPdf"
        @Btn4="updateProcedureDocument"
        @Btn5="closeProcedureDocument"
        @previousPage="setPage"
        @nextPage="setPage"
        @fullReload="reloadPage"
        @readFilteredData="filteredDataManager"
        @filterQuery="tableFilterManager"
      />
    </template>
    <template v-else>
      <h3 style="display: flex; flex-direction: column; align-items: center">
        <span style="font-size: 4rem">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        Acces interzis
      </h3>
    </template>
  </div>
</template>

<script>
import PermisionsMixin from "@/mixins/assignmentsPermMixin.js";
import DialogModal from "@/components/DialogModal";
import AssignmentActions from "@/components/AssignmentActions";
import ProcedureDocuments from "@/components/ProcedureDocuments";
import {
  ASSIGMENTS_REFERENCE_PAGINATED,
  GET_PAAP_CENTRALIZATION,
  PROCEDURE_DOCUMENTS,
} from "@/api.js";
import { mapMutations, mapGetters } from "vuex";
import Table from "@/components/Table";
import { PAAP } from "../api";

export default {
  components: {
    Table,
  },

  mixins: [PermisionsMixin],

  data() {
    return {
      dataLoading: false,
      tableData: {
        ready: 1,
        options: {
          searchModule: (x, y, _, b) => {
            return ASSIGMENTS_REFERENCE_PAGINATED(
              x,
              y,
              `eq=paapCentralization.id,${this.$route.params.centralization}&${b}`,
            );
          },
          refresh: true,
        },
        head: [
          {
            spacer: true,
            minimize: 1,
            fixed: {
              left: true,
            },
          },
          {
            title: "NR.",
            sort: true,
            fixed: {
              left: true,
            },
          },
          {
            title: "Denumire",
            queryKey: "name",
            bottomHead: {
              quikFiltre: true,
            },
          },
          {
            title: "Anul de încadrare",
            queryKey: "nryear",
            bottomHead: {
              quikFiltre: "date",
              dateType: "year",
              dateFormat: "YYYY",
              format: "YYYY",
            },
          },
          {
            title: "Structură organizatorică",
            queryKey: "department.name",
            bottomHead: {
              quikFiltre: true,
            },
          },
          {
            title: "Inițiator",
            queryKey: "createdBy:userName", //createdBy:allUser
            bottomHead: {
              quikFiltre: true,
            },
          },

          {
            title: "Cod CPV (dominant)",
            queryKey: "need.product.cpvCategory.cpvCode",
            bottomHead: {
              quikFiltre: true,
            },
          },
          {
            title: "Valoarea totală estimată, fără TVA",
            queryKey: "totalValueWithoutTva",
            bottomHead: {
              quikFiltre: "number",
            },
          },
          {
            title: "Valoarea totală estimată",
            queryKey: "sumnr",
            bottomHead: {
              quikFiltre: "number",
            },
          },

          {
            spacer: true,
            minimize: 1,
            fixed: {
              right: true,
            },
            queryKey: "acquisition.id",
            bottomHead: {
              tooltip: "Status",
              iconsMap: [
                {
                  tooltip: "Draft",
                  icon: "far fa-clock",
                  color: "#f2da07",
                },
                {
                  tooltip: "Finalizat",
                  icon: "fas fa-badge-check",
                  color: "green",
                },
              ],
              valuesMap: { value: [false, false] },
              queryMap: [
                ["null", "eqn"],
                ["null", "neqn"],
              ],
            },
          },
          {
            spacer: true,
            minimize: 1,
            fixed: {
              right: true,
            },
            bottomHead: {
              quikFiltre: "clear",
            },
          },
        ],
        body: [],
      },
      currentPage: this.getPaginatedParams(),
      totalItemsLength: 0,
      tableFilter: {
        query: "",
        baseQuery: "",
      },

      totalRecords: 0,
      tableReload: 1,
      checkedRows: [],
      centralization: null,
      allSelected: null,
    };
  },
  computed: {
    ...mapGetters(["getProcedureTypes", "getNeedsTableData"]),
  },
  watch: {},
  methods: {
    ...mapMutations({
      setReferenceIdForPreview: "setReferenceIdForPreview",
      saveData: "setNeedsTableData",
    }),
    checkboxManager(val) {
      this.checkedRows = val;
    },
    selectAll(val) {
      this.allSelected = val;
    },
    closePanel() {
      this.$router.push(this.$route.path.slice(0, -2));
    },
    viewPdf(item) {
      let data = this.getNeedsTableData;

      this.setReferenceIdForPreview({
        data: {
          id: data[item].id,
        },
        origin: "REFERENCE_GET_PDF",
      });
    },

    tableFilterManager(newQuery) {
      if (this.isString(newQuery)) {
        this.tableFilter.query = newQuery;
      }
    },

    filteredDataManager(data, callback) {
      if (Number.isInteger(data?.data?.recordsQuantity)) {
        this.totalItemsLength = data.data.recordsQuantity;
      }
      if (Array.isArray(data?.data?.result)) {
        callback([
          this.prepareData(data.data.result, {
            minimize: true,
          }),
          data.data.recordsQuantity,
        ]);
        this.saveData(
          this.prepareData(data.data.result, {
            minimize: false,
          }),
        );
        this.tableData.options.totalItems = parseInt(data.data.recordsQuantity);
        this.currentPage = {
          from: 0,
          to: localStorage.getItem("tableShowPerPage")
            ? parseInt(localStorage.getItem("tableShowPerPage"))
            : 15,
        };
        this.dataLoading = false;
      } else {
        callback([false]);
      }
    },

    prepareData(rows, o = {}) {
      let index = 1;

      const getReferenceStatusIcon = (s) =>
        ({
          draft: {
            border: "left",
            icon: "far fa-clock",
            css: "padding: 0.5rem;color: #f2da07;font-size: 2.2rem;",
            tooltip: "Draft",
          },
          closed: {
            border: "left",
            icon: "fas fa-badge-check",
            css: "padding: 0.5rem; font-size:2.2rem; color: green;",
            tooltip: "Finalizat",
          },
        }[s] || s);

      const preparations = [];

      for (const row of rows) {
        let preparation = [];

        let status = "draft";

        if (this.checkAssignmentDocumentStatus(row.acquisition)) {
          status = "closed";
        } else if (row.acquisition?.procedureDocuments?.length) {
          const procedureDocument = row.acquisition.procedureDocuments[0];
          status = procedureDocument.status;
        }

        let name = "-";
        let cpv = row.need?.product?.cpvCategory?.cpvCode || "-";
        let price = "-";

        if (row.createdByUser) {
          name =
            `${row.createdByUser.last_name || ""} ${
              row.createdByUser.first_name || ""
            } - ` + row?.createdByUser?.id;
        }

        price = this.prepareLocaleNumber(row.sumnr);

        if (
          !this.checkAssignmentDocumentStatus(row.acquisition) &&
          (!row.acquisition?.procedureDocuments || row.acquisition?.procedureDocuments?.length == 0)
        ) {
          preparation.push({
            checkbox: true,
            label:
              row.nryear < new Date().getFullYear()
                ? "Referaul nu mai poate fi selectat, nu se încadrează în anul curent."
                : "",
            disabled: row.nryear < new Date().getFullYear(),
          });
        } else {
          preparation.push({ spacer: true });
        }

        preparation = [
          ...preparation,
          {
            val: index++,
            border: "right",
          },
          row.name || "-",
          row.nryear || "-",
          row.department?.name || "-",
          name,
          cpv,
          this.prepareLocaleNumber(row.totalValueWithoutTva),
          price,
          getReferenceStatusIcon(status),
        ];

        const prepareBtn = [[14]];

        if (row.acquisition?.procedureDocuments?.length) {
          const procedureDocument = row.acquisition?.procedureDocuments[0];

          prepareBtn.push([
            4,
            "Documente",
            ["fas fa-file-plus", "font-size:2.2rem; color: #337ab7;"],
          ]);

          if (procedureDocument.status == "draft")
            prepareBtn.push([
              5,
              "Finalizează procedura",
              ["fas fa-badge-check", "font-size:2.2rem; color: green;"],
            ]);
        }

        preparation = Object.assign([...preparation], {
          id: row.id,
        });

        preparation.push([prepareBtn]);

        if (o.minimize) {
          preparations.push(preparation);
        } else {
          const returnData = {
            id: row.id,
            row: preparation,
            data: row,
            _Data: row,
          };

          preparations.push(returnData);
        }
      }

      if (o.minimize) {
        preparations.forEach((e, i) => (e._ID = i));
      } else if (o.minimize === false || o.numerotate) {
        preparations.forEach((e, i) => {
          e.NR = i;
          e.index = i;
        });
      }

      return preparations;
    },

    reloadPage(changePage) {
      this.saveData([]);
      this.tableData.body.splice(0);
      this.tableReload = 1;
      this.totalItemsLength = 0;
      this.totalRecords = 0;
      (this.currentPage = this.getPaginatedParams()),
        (this.dataLoading = false);
      this.tableFilter.query = "";
      this.managePages(changePage);
    },
    setPage(from, to) {
      if ((!parseInt(from) && from !== 0) || (!parseInt(to) && to !== 0)) {
        return;
      }

      this.currentPage.from = from;
      this.currentPage.to = to;

      this.managePages();
    },
    async getNeedReferenceData(showPerPage, page) {
      let prepare = [];

      this.tableFilter.baseQuery = `eq=paapCentralization.id,${this.$route.params.centralization}`;

      let filter = this.tableFilter.baseQuery;

      if (this.tableFilter.query) {
        filter =
          this.tableFilter.baseQuery.concat(`&${this.tableFilter.query}`) ||
          false;
      }

      let response = await ASSIGMENTS_REFERENCE_PAGINATED(
        page,
        showPerPage,
        filter,
      );

      if (Number.isInteger(response?.data?.recordsQuantity)) {
        this.totalItemsLength = response.data.recordsQuantity;
        this.tableData.options.totalItems = response.data.recordsQuantity;
      }

      prepare = this.prepareData(response.data.result);
      return prepare;
    },

    async managePages(changePage) {
      if (this.dataLoading) {
        return;
      }

      this.dataLoading = true;
      let data = this.getNeedsTableData;

      const { from, to } = this.currentPage;
      const show = to - from;
      const currentPage = from / (to - from) + 1;
      const totalItems = this.totalItemsLength;

      if (to >= totalItems && data.length && changePage !== true) {
        return;
      }

      let uploadPages = [];
      let reloadRowsAfterChangeShow = false;

      if (currentPage > 0) {
        if (!data[from]) {
          uploadPages.push(currentPage);
        } else if (data[from] && !data[to - 1]) {
          this.tableData.body = [];
          data = [];
          reloadRowsAfterChangeShow = true;
          uploadPages.push(currentPage);
        }
      }

      if (Math.ceil(totalItems / show) - currentPage > 0) {
        if (!data[to]) {
          uploadPages.push(currentPage + 1);
        }
      }
      if (currentPage - 1 >= 1) {
        if (!data[from - show]) {
          uploadPages.push(currentPage - 1);
        }
      }
      if (
        this.tableReload === 1 &&
        uploadPages.length < 2 &&
        uploadPages.indexOf(currentPage + 1) == -1
      ) {
        uploadPages.push(currentPage + 1);
      }

      if (uploadPages.length) {
        let preparation = [];

        for (const page of uploadPages) {
          const getNeedsPage = await this.getNeedReferenceData(show, page);
          preparation.push(getNeedsPage);
        }
        preparation = preparation.flat(1);

        let lastRowIndex = data[data.length - 1]
          ? data[data.length - 1].index + 1
          : 1;

        const prepare = preparation.map((el) => {
          el.row[1].val = lastRowIndex++;
          return el.row;
        });

        data.push(preparation);

        data = data.flat(1);

        data.forEach((e, i) => {
          e.NR = i;
          e.index = i;
        });

        this.saveData(data);

        this.tableData.body =
          this.tableData.body.concat(prepare).length === 0
            ? [false]
            : this.tableData.body.concat(prepare);

        if (reloadRowsAfterChangeShow || this.tableReload == 1)
          this.tableReload++;
      }
      this.dataLoading = false;
    },

    async openActions() {
      if (
        this.checkedRows.length == 0 &&
        !this.allSelected &&
        !this.centralization.imported
      ) {
        this.$toastr.w("Nu a fost selectat nici un referat.");
        return;
      }

      //this.setLoad(true);
      // const approved = await PAAP.checkPaapApproved(this.centralization.paap.id)
      //   .then((res) => {
      //     if (!this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
      //       this.$toastr.e(res.response);
      //       this.setLoad();
      //       return;
      //     }
      //     this.setLoad();
      //     return true;
      //   })
      //   .catch((err) => {
      //     this.$toastr.e(err.message);
      //     this.setLoad();
      //     return;
      //   });

      // if (!approved) {
      //   return;
      // }

      const needReferences = this.getNeedsTableData
        .map((el) => el.data)
        .filter((k) => this.checkedRows.find((x) => k.id === x.id));

      this.$modal.show(
        DialogModal,
        {
          target: "ActiuniAchizitie",
          title: "Acțiuni achiziții",
          inputs: [
            {
              id: "assignmentActions",
              type: "component",
              component: AssignmentActions,
              errReason: "",
              componentProps: {
                centralization: this.centralization,
                needReferences: this.allSelected ? "all" : needReferences,
              },
            },
          ],
          closeBtnText: "Anulează",
          button: {
            disabled: true,
          },
          customClass: "fullWidth",
        },
        {
          name: "ActiuniAchizitie",
          adaptive: true,
          width: "650px",
          height: "570px",
        },
      );
    },

    async createProcedureDocument() {
      if (this.checkedRows.length == 0 && !this.allSelected) {
        this.$toastr.w("Nu a fost selectat nici un referat.");
        return;
      }
      this.$modal.show(
        DialogModal,
        {
          target: "CreateProcedureDocument",
          title: "Creare procedură",
          inputs: [
            {
              id: "files",
              type: "component",
              component: ProcedureDocuments,
              componentProps: { procedureDocument: null },
              errReason: "Nu a fost încărcat nici un fișier.",
            },
          ],
          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Salvează",
            handler: (data) => {
              const error = (msg) => {
                this.$toastr.e(msg || "Procedura nu a fost creată.");
                this.setLoad();
              };

              this.setLoad(true);

              const sendData = new FormData();

              sendData.append("paapCentralizationId", this.centralization.id);
              sendData.append(
                "needReferences",
                this.allSelected
                  ? "all"
                  : JSON.stringify(this.checkedRows.map((el) => el.id)),
              );

              data.files
                .filter((e) => !e.deleted)
                .forEach((file) => {
                  sendData.append("files", file.file);
                });

              PROCEDURE_DOCUMENTS.createProcedureDocument(sendData)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Procedura a fost salvată.");
                    this.reloadPage();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
          customClass: "fullWidth",
        },
        {
          name: "CreateProcedureDocument",
          adaptive: true,
          width: "1000",
          height: "1000",
        },
      );
    },

    async updateProcedureDocument(index) {
      const find = this.getNeedsTableData.find((e) => e.index === index);

      const item = find.data.acquisition?.procedureDocuments[0] || {};

      this.$modal.show(
        DialogModal,
        {
          target: "updateProcedureDocument",
          title: "Adaugare document",
          inputs: [
            {
              id: "files",
              type: "component",
              component: ProcedureDocuments,
              componentProps: { procedureDocument: item },
              errReason: "Nu a fost încărcat nici un fișier.",
            },
          ],

          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Salvează",
            handler: (data) => {
              const error = (msg) => {
                this.$toastr.e(msg || "Documentele nu au fost salvate.");
                this.setLoad();
              };

              this.setLoad(true);

              const sendData = new FormData();

              data.files
                .filter((e) => !e.deleted)
                .forEach((file) => {
                  sendData.append("files", file.file);
                });

              PROCEDURE_DOCUMENTS.addDocuments(item.id, sendData)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Documentele nu au fost adăugate.");
                    this.reloadPage();
                    this.setLoad();
                  } else {
                    error();
                  }
                })
                .catch(error);
            },
          },
          customClass: "fullWidth",
        },
        {
          name: "updateProcedureDocument",
          adaptive: true,
          width: "1000",
          height: "1000",
        },
      );
    },

    closeProcedureDocument(index) {
      const find = this.getNeedsTableData.find((e) => e.index === index);

      const item = find.data.acquisition?.procedureDocuments[0] || {};
      this.$modal.show(
        DialogModal,
        {
          target: "CloseAssignmentDocumentDocument",
          title: "Doriți să finalizați procedura?",
          inputs: [],
          closeBtnText: "Anulează",
          button: {
            type: 2,
            value: "Salvează",
            handler: () => {
              const error = (msg) => {
                this.$toastr.e(msg || "Eroare la finalizarea procedurii.");
                this.reloadPage();
                this.setLoad();
              };

              this.setLoad(true);
              PROCEDURE_DOCUMENTS.close(item.id)
                .then((res) => {
                  if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
                    this.$toastr.s("Procedura a fost finalizată.");
                    this.reloadPage();
                    this.setLoad();
                  } else {
                    error(res.response);
                  }
                })
                .catch(error);
            },
          },
        },
        {
          name: "CloseAssignmentDocumentDocument",
          adaptive: true,
          width: "550",
          height: "300",
        },
      );
    },

    checkAssignmentDocumentStatus(acquisition) {
      if (acquisition) return true;
      return false;
    },
  },

  created() {
    GET_PAAP_CENTRALIZATION(this.$route.params.centralization).then((res) => {
      this.centralization = res.data;
      const path = this.$route.path;
      const val = path.slice(0, path.lastIndexOf("/"));
      this.$root.$emit("select-item", val);
    });

    this.reloadPage(true);
  },
};
</script>

<style>
.fullWidth {
  max-width: 100% !important;
  max-height: 100% !important;
}
</style>
